import { FloorTable, Room, TableShape } from '../types/floorPlan.model'

export const QUERY = {
  FLOOR_PLAN: 'floor-plan'
} as const

/**
 * Backend DTOs, mirror the OpenAPI schemas in src/api/core/api.json
 * (FloorPlanRoomDto, FloorTableDto, GetTableDto, UpdateTableDto, DeleteTablesDto).
 *
 * The backend models the floor plan as a list of rooms with their tables
 * nested inside, a table's room membership is expressed by nesting, not by a
 * `roomId` field, and a table is identified by a numeric `number` rather than a
 * string label. The local store keeps the flat shape the components render from
 * (see floorPlanMapper.ts for the translation).
 */

// GET/PUT /restaurants/{restaurantId}/floor-plan. FloorTableDto
export interface FloorTableDto {
  id?: string // uuid; omit when creating a new table
  number: number // 1..32767, integration key with the QR table number
  shape: TableShape
  seatCount: number // >= 0
  x: number
  y: number
  width: number // >= 40; for round/square equals height
  height: number // >= 40
  rotation: number // degrees
}

// GET/PUT /restaurants/{restaurantId}/floor-plan. FloorPlanRoomDto
export interface FloorPlanRoomDto {
  id?: string // uuid; omit when creating a new room
  name: string
  tables: FloorTableDto[]
}

// GET /restaurants/{restaurantId}/tables. GetTableDto (operational table list)
export interface GetTableDto {
  id: string
  number: number
  roomId?: string | null
  room?: string | null
  qrCodeCardId?: string
}

// PUT /restaurants/{restaurantId}/tables/{tableId}. UpdateTableDto
export type TableStatus =
  | 'free'
  | 'occupied'
  | 'serving'
  | 'served'
  | 'paid'
  | 'needsCleaning'

export interface UpdateTableDto {
  status: TableStatus
}

// DELETE /restaurants/{restaurantId}/tables. DeleteTablesDto
export interface DeleteTablesDto {
  ids: string[]
}

export type { Room, FloorTable }
